import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.scss'],
})
export class ModulesComponent implements OnInit {
  @Input() data: any;

  constructor() {}

  ngOnInit(): void {}
}
